<!-- #3 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        SLA Order Tracking
      </div>
      <v-spacer></v-spacer>
    </div>
    <v-divider class="mt-1 mb-4 mr-8"></v-divider>
    <v-data-table
      :headers="headers"
      :items="slaList"
      :loading="loader"
      :search="search"
      class="elevation-1 custom-icon-size mr-8"
      :server-items-length="total"
      :options.sync="options"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <template>
          <v-form>
            <div class="custom-row p-5 pr-1">
              <v-col cols="12" sm="3" md="3" class="pb-0">
                <v-autocomplete
                  v-model="client_id"
                  :items="clients"
                  :loading="clientLoader"
                  hide-no-data
                  item-text="name"
                  item-value="id"
                  label="Select Client"
                  placeholder="Start typing to Search"
                  class="text-center pb-0"
                  @focus="fetchClientList"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" md="3" class="pb-0">
                <v-select
                  v-model="carrier_id"
                  label="Select Carrier"
                  class="pt-0 pb-0"
                  item-text="name"
                  item-value="id"
                  :items="activeCarriersListTypes"
                  outlined
                  @focus="fetchCarriers()"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  outlined
                  v-model="tracking_no"
                  dense
                  chips
                  small-chips
                  label="Tracking No."
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  outlined
                  v-model="order_reference"
                  dense
                  chips
                  small-chips
                  label="Order Ref."
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="3">
                <v-autocomplete
                  :items="paymentModes"
                  outlined
                  v-model="payment_type"
                  dense
                  chips
                  small-chips
                  label="Payment Mode"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  v-model="duty_handling"
                  :items="dutyhandlings"
                  outlined
                  item-text="text"
                  item-value="value"
                  small-chips
                  label="Duty Handling"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  v-model="delivery_Type"
                  :items="deliveryTypes"
                  outlined
                  item-text="text"
                  item-value="value"
                  small-chips
                  label="Delivery Type"
                  @input="getService(delivery_Type)"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" v-if="delivery_Type">
                <v-autocomplete
                  v-model="service_type"
                  :items="servicesTypes"
                  outlined
                  :item-text="
                    (item) => `${item.service_name} - (${item.service_code})`
                  "
                  item-value="service_code"
                  small-chips
                  label="Service Type"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  v-model="country"
                  :items="countries"
                  outlined
                  dense
                  chips
                  item-text="name"
                  item-value="id"
                  small-chips
                  label="Destination Country"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" class="pb-0">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(from_date)"
                      label="Order From Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearDateInput('this.from_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="from_date"
                    @input="dateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="3" class="pb-0">
                <v-menu
                  v-model="dateMenuTo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  class="custom-text-field"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(to_date)"
                      label="Order To Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearDateInput('this.to_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="to_date"
                    @input="dateMenuTo = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  :items="statuses"
                  outlined
                  v-model="status"
                  dense
                  chips
                  small-chips
                  label="Status"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" :sm="delivery_Type ? '12' : '3'">
                <v-btn
                  color="white"
                  @click="clearAll"
                  style="float: right"
                  class=""
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success mr-5"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
              </v-col>
            </div>
          </v-form>
          <v-divider class="mb-2"></v-divider>
        </template>
      </template>
      <template v-slot:[`item.order_date`]="{ item }">
        {{ item.order_date | localMoment | moment("DD MMM, YYYY hh:mm A") }}
      </template>
      <template v-slot:[`item.created_at`]="{ item }">
        {{ item.created_at | localMoment | moment("DD MMM, YYYY hh:mm A") }}
      </template>
      <template v-slot:item.delivery_type="{ item }">
        {{ firstLetterCapital(item.delivery_type) }}
      </template>
      <template v-slot:[`item.tracking_number`]="{ item }">
        <a @click="fetchTrackingDetails(item.tracking_number)">{{
          item.tracking_number
        }}</a>
      </template>
      <template v-slot:[`item.updated_at`]="{ item }">
        {{ item.updated_at | localMoment | moment("DD MMM, YYYY hh:mm A") }}
      </template>

      <template v-slot:item.name="{ item }">
        {{ item.name }}
      </template>
      <template v-slot:item.status="{ item }">
        <v-chip
          v-if="item.status"
          :color="
            item.status === 'Not Started'
              ? 'grey lighten-2'
              : item.status === 'In Transit'
              ? 'yellow lighten-2'
              : item.status === 'Maybe Delayed'
              ? 'blue lighten-2'
              : item.status === 'Delivery Delayed'
              ? 'red lighten-2'
              : 'green lighten-2'
          "
          class="ma-2"
          small
        >
          {{ item.status }}
        </v-chip>
      </template>
    </v-data-table>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},

  computed: {
    ...mapGetters(["userCategory"]),
  },
  data: () => ({
    country: null,
    dateMenuTo: false,
    dateMenu: false,
    options: {},
    payment_type: null,
    to_events: [],
    from_events: [],
    carrier_id: null,
    duty_handling: null,
    start_event_code: null,
    from_date: null,
    to_date: null,
    tracking_no: null,
    total: 0,
    paymentModes: [
      {
        text: "COD",
        value: "COD",
      },
      {
        text: "Prepaid",
        value: "Prepaid",
      },
    ],
    deliveryTypes: [
      { text: "Cross Border", value: "crossborder" },
      { text: "Domestic", value: "domestic" },
    ],
    dutyhandlings: [
      { text: "DDU", value: "ddu" },
      { text: "DDP", value: "ddp" },
    ],
    servicesTypes: [],
    statuses: [
      {
        text: "Not Started",
        value: 0,
      },
      {
        text: "In Transit",
        value: 1,
      },
      {
        text: "Maybe Delayed",
        value: 2,
      },
      {
        text: "Delivery Delayed",
        value: 3,
      },
      {
        text: "On Time Delivered",
        value: 4,
      },
    ],
    headers: [
      {
        text: "SLA Name",
        value: "sla_name",
        class: "body-1 font-weight-bold",
        width: "200px",
        sortable: false,
      },

      {
        text: "Client",
        value: "client_name",
        class: "body-1 font-weight-bold",
        width: "200px",
        sortable: false,
      },
      {
        text: "Carrier",
        value: "carrier_name",
        class: "body-1 font-weight-bold",
        width: "200px",
        sortable: false,
      },

      {
        text: "Tracking No",
        value: "tracking_number",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Order Ref.",
        value: "order_reference",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Order Date",
        value: "order_date",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "120px",
      },
      {
        text: "Payment Type",
        value: "payment_type",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Delivery Type",
        value: "delivery_type",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Duty Handling",
        value: "duty_handling",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Service Type",
        value: "service_type",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Destination Country",
        value: "destination_country",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "SLA Config Time",
        value: "sla_config_time_in_hrs",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Calculated Time",
        value: "calculated_time_in_hrs",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Start Event Code",
        value: "start_event_code",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "End Event Code",
        value: "end_event_code",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Status",
        value: "status",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Created At",
        value: "created_at",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Updated At",
        value: "updated_at",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
    ],
    delivery_Type: null,
    slaList: [],
    editedIndex: -1,
    editedItem: {
      name: null,
      active: true,
    },
    search: null,
    dialogConfirm: false,
    loader: false,
    statusLoader: false,
    remvLinehaul: false,
    carrierId: null,
    active: "",
    label_type_id: "",
    service_type: "",
    activeCarriersListTypes: [],
    clients: [],
    payment_mode: "",
    order_reference: "",
    countries: [],
  }),

  created() {
    this.fetchCarriers();
    this.fetchClientList();
    this.getCountryList();
  },
  watch: {
    options: {
      handler() {
        this.fetchSla();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "getSlaOrder",
      "changeSlatatus",
      "snackBar",
      "addSLA",
      "getAddCarrier",
      "summaryEvent",
      "getCarriersDropdown",
      "fetchClient",
      "getRSAServiceListOnly",
      "getCountries",
    ]),
    getCountryList() {
      this.getCountries().then((res) => {
        this.countries = res.data;
      });
    },
    getService(service) {
      if (this.userCategory.user_category === 3) {
        service = Array.isArray(service) ? service.join(",") : service;
        this.getRSAServiceListOnly(service).then((res) => {
          this.servicesTypes = res.data;
        });
      }
    },
    fetchClientList() {
      if (this.clients.length) return;
      if (this.clients.length === 0 && this.userCategory.user_category === 3) {
        this.clientLoader = true;
        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "clickdna,fulfillment_wid_last_mile",
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
    fetchTrackingDetails(item) {
      window.open(
        this.$router.resolve({
          name: "ClientTrackingDetails",
          query: {
            id: item,
          },
        }).href,
        "_blank"
      );
    },
    async fetchCarriers() {
      if (this.activeCarriersListTypes.length) return;
      await this.getCarriersDropdown({
        pagination: 0,
        active: "all",
      })
        .then((res) => {
          this.activeCarriersListTypes = res.data;
        })
        .catch(() => {
          this.loader = false;
        });
    },
    clearDateInput(value) {
      if (value == "this.from_date") {
        this.from_date = null;
      } else {
        this.to_date = null;
      }
    },
    fetchEvent() {
      this.summaryEvent().then((res) => {
        this.from_events = res.data.sla_event_list.from_events;
        this.to_events = res.data.sla_event_list.to_events;
      });
    },
    ServiceTypes() {
      this.allServiceTypes = Object.keys(this.addList.list_service_type).map(
        (i) => {
          return {
            text: this.capitalizeFirstLetter(i),
            value: i,
          };
        }
      );
    },
    getAddCarrierList() {
      this.getAddCarrier().then((res) => {
        this.addList = res.data;
        this.ServiceTypes();
      });
    },
    fetchSla() {
      this.loader = true;
      this.getSlaOrder({
        ...this.filtersArr,
        ...this.options,
      })
        .then((res) => {
          this.loader = false;
          this.slaList = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.loader = false;
        });
    },

    setting(item) {
      this.$router.push({
        name: "Slaettings",
        params: {
          id: item.id,
          status: item.active,
        },
      });
    },

    changeStatus() {
      this.statusLoader = true;
      this.changeSlatatus({
        id: this.editedItem.id,
        state: this.editedItem.active ? "active" : "inactive",
      })
        .then((res) => {
          this.statusLoader = false;
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          if (this.editedItem.active == false) {
            this.remvLinehaul = true;
          }

          this.dialogConfirm = false;
        })
        .catch(() => {
          this.statusLoader = false;
          this.closeConfirm();
        });
    },

    editCarrier(item) {
      this.$router.push({
        name: "CarrierEdit",
        params: {
          id: item.id,
        },
      });
    },

    uploadCarrier(item) {
      this.$router.push({
        name: "CarrierEventsUpload",
        params: {
          id: item.id,
          name: item.name,
        },
        query: { carrier_id: item.id },
      });
    },
    clearInput(val) {
      if (val !== "") {
        val = "";
      }
    },
    clearAll() {
      this.payment_type = null;
      this.carrier_id = null;
      this.from_date = null;
      this.to_date = null;
      this.client_id = null;
      this.tracking_no = null;
      this.status = null;
      this.order_reference = null;
      this.service_type = null;
      this.delivery_Type = null;
      this.duty_handling = null;
      this.country = null;
      this.searchAll();
    },
    allFilters() {
      this.orderLoader = true;
      let obj = {
        payment_type: this.payment_type,
        carrier_id: this.carrier_id,
        client_id: this.client_id,
        payment_mode: this.payment_mode,
        from_date: this.from_date,
        to_date: this.to_date,
        status: this.status,
        tracking_number: this.tracking_no,
        order_reference: this.order_reference,
        destination_country_id: this.country,
        service_type: this.service_type,
        delivery_type: this.delivery_Type,
        duty_handling: this.duty_handling,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    searchAll() {
      this.loader = true;
      this.options.page = 1;
      this.allFilters();
      this.getSlaOrder({
        ...this.filtersArr,
        ...this.options,
      })
        .then((res) => {
          this.loader = false;
          this.slaList = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.loader = false;
        });
    },
    goToddress(item) {
      this.$router.push({
        name: "SlaAddresses",
        params: {
          id: item.id,
          name: item.name,
        },
      });
    },
    goToDetails(id) {
      this.$router.push({
        name: "SlaDetails",
        params: {
          id,
        },
      });
    },
    goToUpload(item) {
      this.$router.push({
        name: "CountryUpload",
        params: {
          id: item.id,
          name: item.name,
        },
        query: { carrier_id: item.id },
      });
    },

    getImage(url) {
      if (url == null || url == undefined || url == "") {
        return;
      } else {
        return "/images/logo/" + url.split("/").pop();
      }
    },

    collectFormData() {
      const payload = new FormData();
      for (const field in this.carrierDetail) {
        if (field === "logo") continue;
        payload.append(
          field,
          this.carrierDetail[field] === null ? "" : this.carrierDetail[field]
        );
      }
      if (this.fileInput) {
        payload.append("logo", this.fileInput);
        this.carrierDetail.logo = URL.createObjectURL(this.fileInput);
      }
      return payload;
    },
  },
};
</script>
<style>
.carrier-logo {
  max-width: 100px;
  height: 25px;
}
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 20px 5px 5px !important;
}
.badge {
  display: inline-block;
  padding: 4px 10px;
  background-color: rgb(242, 126, 126);
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
.badge-active {
  display: inline-block;
  padding: 4px 10px;
  background-color: green;
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
</style>
